import { questionType } from 'dygc'

const cascadePlaceholders = new Map()
const SCHOOL = ['请选择省份', '请选择城市', '请选学校']
const SPECIALITY = ['请选择学科', '请选择专业']
const ADDRESS = ['请选择省份', '请选择城市', '请选择区（县）']

function buildMap(types, data, cascadePlaceholders) {
  types.forEach(type => {
    cascadePlaceholders.set(type, data)
  })
}

buildMap([questionType.SCHOOL], SCHOOL, cascadePlaceholders)
buildMap([questionType.SPECIALITY], SPECIALITY, cascadePlaceholders)
buildMap([questionType.CITY_ADDRESS, questionType.PERMANENT_ADDRESS, questionType.DOMICILE], ADDRESS, cascadePlaceholders)

export { cascadePlaceholders }
